import { z } from 'zod';

const progressSchema = z.object({
  lives: z.number().int().nonnegative(),
  maxLives: z.number().int().positive(),
  coins: z.number().int().nonnegative(),
  nextLifeAt: z.string().nullish(),
  inventory: z.object({
    fiftyFifty: z.number().int().nonnegative(),
    swapFrame: z.number().int().nonnegative(),
    freeze: z.number().int().nonnegative(),
  }),
});

export const parseGameResources = (value: unknown) => {
  const progress = progressSchema.parse(value);
  const nextLifeAt = progress.nextLifeAt ? Date.parse(progress.nextLifeAt) : null;
  if (nextLifeAt !== null && !Number.isFinite(nextLifeAt)) throw new Error('Invalid life recovery time');
  return { ...progress, nextLifeAt };
};
